 <template>
    <div class="maskbg">
        <div class="dialog infoDig">
            <div class="close" @click="handleClose"></div>
            <div class="main">
                {{info}}
            </div>
        </div>
        <Info v-if="gwygShow" :visible.sync="gwygShow" :info="jsonData.gwyg"></Info>
    </div>
</template>

<script>
import axios from 'axios'
import Info from './gylc.vue'
export default {
    components: {Info},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>